export const UPLOAD_DATA = "UPLOAD_DATA";
